import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _trimInstanceProperty from "@babel/runtime-corejs3/core-js/instance/trim";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/slice";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _Promise from "@babel/runtime-corejs3/core-js/promise";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ApplicationChangelog from "./changelog/application-changelog.vue";
import ApplicationFeatureDiscovery from "@Broker/@Modules/sidebar/feature-discovery/application-feature-discovery-container.vue";
import ApplicationHeaderLoader from "./header-components/application-header-loader.vue";
import ApplicationSyncStatusBadge from "./header-components/application-sync-status-badge.vue";
import BulkRequestModal from "./header-components/bulk-request-modal.vue";
import ApplicationLockButton from "./header-components/application-lock-button.vue";
import CraRequestModal from "./header-components/cra-request-modal.vue";
import ESignModal from "./header-components/e-sign-modal.vue";
// import ConfirmSyncApplicationToProfile from "./header-components/confirm-sync-application-to-profile.vue";
import ManageAutomationsModal from "./header-components/manage-automations-modal.vue";
import ShowSubscriptionModal from "./header-components/show-subscription-modal.vue";
import GenerateEmailModal from "./header-components/generate-ai-email-modal.vue";
import BackButton from "@Shared/components/general/back-button.vue";
import ApplicantRedirectableName from "./applicant-redirectable-name.vue";
import RefreshableTimeAgo from "@Shared/components/general/refreshable-timeago.vue";
import { mapState, mapActions, mapGetters } from "vuex";
import AddToBoardDropdown from "./header-components/add-to-board-dropdown.vue";
import ClientProfileQuickActionsModal from "./header-components/client-profile-quick-actions/client-profile-quick-actions-modal.vue";
import { COLLABORATOR_USERNAMES } from "@Broker/@Modules/clients/board/store/board-getters";
import { LOAD_BOARD_COLLABORATORS, LOAD_CLIENT_PROFILE_DETAILS, LOAD_CUSTOM_FIELDS_DEFINITIONS, LOAD_BOARDS } from "@Broker/@Modules/clients/board/store/board-actions";
import { BOARDS } from "@Broker/@Modules/clients/board/store/board-getters";
import { showBModal } from "@Shared/components/bootstrap/BModal";
import ApplicationStatusBadge from "@Shared/components/general/application-status-badge.vue";
import { LOAD_SYNCED_EMAILS } from "@Broker/@Modules/settings/store/settings-actions";
import { LOAD_EMAIL_SIGNATURE } from "@Broker/@Modules/main/store/account/account-actions";
import { ACCOUNT_EMAIL_SIGNATURE } from "@Broker/@Modules/main/store/account/account-getters";
import { APPLICATION_CLIENT_DETAILS, CURRENT_APPLICATION, IS_APPLICATION_SYNCABLE } from "@Broker/@Modules/clients/applications/application/store/application-getters";
import ApplicantAvatar from "./header-components/applicant-avatar.vue";
import * as pop from "@Shared/utils/vue/directives/open-window-popover";
import { GET_SYNCED_EMAILS } from "@Broker/@Modules/settings/store/settings-getters";
import { showToast } from "@Shared/@Utils/constants";
import { defineComponent } from "@vue/composition-api";
import { postMainApi } from "@Shared/@Utils/ajax";
import Err from "@Broker/@Routes/error";
export default defineComponent({
  name: "ApplicationHeader",
  components: {
    ApplicationStatusBadge,
    CraRequestModal,
    ApplicationLockButton,
    BackButton,
    RefreshableTimeAgo,
    ApplicantRedirectableName,
    ESignModal,
    ApplicationHeaderLoader,
    AddToBoardDropdown,
    ClientProfileQuickActionsModal,
    BulkRequestModal,
    ManageAutomationsModal,
    ShowSubscriptionModal,
    GenerateEmailModal,
    ApplicationSyncStatusBadge,
    ApplicantAvatar,
    ApplicationFeatureDiscovery,
    ApplicationChangelog
    // ConfirmSyncApplicationToProfile
  },
  props: {
    givenName: {
      type: String,
      default: ""
    },
    familyName: {
      type: String,
      default: ""
    },
    accountStatus: {
      type: String,
      default: ""
    },
    verified: {
      type: Boolean,
      default: false
    },
    clientUsername: {
      required: true,
      validator: prop => typeof prop === "string" || prop === null
    },
    agentUsername: {
      required: true,
      validator: prop => typeof prop === "string" || prop === null
    },
    applicationId: {
      required: true,
      validator: prop => typeof prop === "number" || prop === null
    },
    loading: {
      type: Boolean,
      required: true
    },
    saving: {
      type: Boolean
    },
    backPath: {
      type: String,
      default: ""
    },
    applicationInfo: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      backHref: this.backPath || "#/clients/applications",
      noaDisabled: false,
      // TODO Hiding NOA functionality since MrTaxes no longer allowed to obtain it
      selectedQuickAction: "",
      selectedClientProfileId: null,
      loadingProfile: false,
      rollbackLoading: false,
      showChangelog: false
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapState("AccountStore", ["userDetails", "accountPreferences"])), mapState("BoardStore", {
    clientProfiles(state) {
      return state.clientProfiles.byId;
    }
  })), mapGetters("AccountStore", [ACCOUNT_EMAIL_SIGNATURE])), mapGetters("SettingsStore", [GET_SYNCED_EMAILS])), mapGetters("BoardStore", [COLLABORATOR_USERNAMES, BOARDS])), mapGetters("ApplicationStore", [IS_APPLICATION_SYNCABLE, APPLICATION_CLIENT_DETAILS, CURRENT_APPLICATION])), {}, {
    updatedAt() {
      const {
        updatedAt
      } = this.CURRENT_APPLICATION;
      return updatedAt;
    },
    applicationStatus() {
      const {
        applicationStatus
      } = this.CURRENT_APPLICATION;
      return applicationStatus;
    },
    subscription() {
      return this.CURRENT_APPLICATION.subscription || [];
    },
    clientDetails() {
      return this.APPLICATION_CLIENT_DETAILS(this.clientUsername);
    },
    fullName() {
      var _this$applicationInfo, _context, _context2;
      const mainApplicant = ((_this$applicationInfo = this.applicationInfo["main-applicant"]) == null ? void 0 : _this$applicationInfo["personal-details"]) || {};
      const firstName = mainApplicant["first-name"] || this.givenName || "";
      const lastName = mainApplicant["last-name"] || this.familyName || "";
      return _trimInstanceProperty(_context = _mapInstanceProperty(_context2 = [firstName, lastName]).call(_context2, name => {
        var _context3;
        return _mapInstanceProperty(_context3 = name.split(" ")).call(_context3, word => word.charAt(0).toUpperCase() + _sliceInstanceProperty(word).call(word, 1).toLowerCase()).join(" ");
      }).join(" ")).call(_context);
    },
    linkedProfiles() {
      return this.applicationInfo.linkedProfiles || [];
    },
    thereAreLinkedProfiles() {
      var _this$linkedProfiles;
      return !!((_this$linkedProfiles = this.linkedProfiles) != null && _this$linkedProfiles.length);
    },
    selectedClientProfile() {
      var _context4;
      if (this.selectedClientProfileId === null) return this.linkedProfiles[0];
      return _findInstanceProperty(_context4 = this.linkedProfiles).call(_context4, ({
        clientProfileId
      }) => clientProfileId === this.selectedClientProfileId);
    },
    currentAgentIsCollaborator() {
      const collaborators = [this.agentUsername, ...this.COLLABORATOR_USERNAMES(this.boardId)];
      return _includesInstanceProperty(collaborators).call(collaborators, this.userDetails.username);
    },
    showApplicationFeatureDiscovery() {
      return this.IS_APPLICATION_SYNCABLE(this.applicationId) && this.accountPreferences.applicationFeatureDiscovery && (this.$route.name === "application" || this.$route.name === "application-filogix");
    },
    avatarInitials() {
      const [givenName, familyName] = this.fullName.split(" ");
      return `${_trimInstanceProperty(givenName).call(givenName).charAt(0)}${_trimInstanceProperty(familyName).call(familyName).charAt(0)}`;
    },
    isApplicationCompleted() {
      return this.CURRENT_APPLICATION.applicationStatus === "completed" || this.CURRENT_APPLICATION.applicationStatus === "cancelled";
    }
  }),
  watch: {
    selectedClientProfile: {
      immediate: true,
      async handler(value = {}) {
        // do not re-fetch if the client profile was already loaded
        const {
          clientProfileId,
          boardId
        } = value;
        if (clientProfileId && !this.clientProfiles[clientProfileId]) {
          this.loadingProfile = true;
          await this.LOAD_CLIENT_PROFILE_DETAILS({
            clientProfileId
          });
          await _Promise.all([this.LOAD_SYNCED_EMAILS(), this.LOAD_EMAIL_SIGNATURE(), this.LOAD_BOARD_COLLABORATORS({
            boardId
          }), this.LOAD_CUSTOM_FIELDS_DEFINITIONS({
            boardId
          })]);
          this.loadingProfile = false;
        }
      }
    }
  },
  async updated() {
    if (!this.BOARDS.length) await _Promise.all([this.LOAD_BOARDS()]);
    this.$nextTick(() => $("[data-toggle='tooltip']").tooltip());
  },
  methods: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapActions("SettingsStore", [LOAD_SYNCED_EMAILS])), mapActions("AccountStore", [LOAD_EMAIL_SIGNATURE])), mapActions("BoardStore", [LOAD_BOARD_COLLABORATORS, LOAD_CLIENT_PROFILE_DETAILS, LOAD_CUSTOM_FIELDS_DEFINITIONS, LOAD_BOARDS])), {}, {
    handleOpenModal(target) {
      if (target === "craRequestModal" && this.noaDisabled) return;
      this.$refs[target].openModal();
    },
    handleOpenQuickActionsModal(quickActionName) {
      this.selectedQuickAction = quickActionName;
      this.openQuickActionsModal();
    },
    handleSelectedProfile(clientProfileId) {
      this.selectedClientProfileId = clientProfileId;
    },
    openQuickActionsModal() {
      showBModal("quick-actions-modal", {}, this);
    },
    showESignModal() {
      showBModal("e-sign-modal", {}, this);
    },
    openGenerateEmailModal() {
      showBModal("generate-email-modal", {}, this);
    },
    getCalculatorsUrl() {
      return ` ${this.$options.filters.portalDomain("client", true)}#/calculations`;
    },
    showGenerateEmailOption() {
      const emailsSynced = this.GET_SYNCED_EMAILS;
      return this.applicationInfo["main-applicant"]["personal-details"]["email"] && emailsSynced.allIds.length;
    },
    openCRARequestModal() {
      if (this.noaDisabled) return;
      this.$bvModal.show("cra-request-modal");
    },
    handleSyncApplication() {
      const {
        applicationId,
        clientUsername
      } = this;
      const {
        succeeded
      } = this.SYNC_APPLICATION_TO_CLIENT_PROFILE({
        applicationId,
        clientProfileId: this.selectedClientProfile.clientProfileId,
        clientUsername
      });
      if (succeeded) showToast("success", "linkedApplicationSynchronized");
    },
    windowPopoverUrl() {
      const {
        agentUsername,
        clientUsername,
        applicationId
      } = this;
      return `#/widgets/applications/${applicationId}/client/${clientUsername}/agent/${agentUsername}/validation-rules`;
    },
    openValidWidgetPopover() {
      const windowPopoverUrl = this.windowPopoverUrl();
      pop.openWidgetPopover(this, {
        url: windowPopoverUrl,
        width: 900,
        height: 600
      });
    },
    async confirmRollbackStatus() {
      this.rollbackLoading = true;
      try {
        const {
          clientUsername,
          applicationId
        } = this;
        await postMainApi({}, `/client/${clientUsername}/application/${applicationId}/rollback-status`);
        this.$bvModal.hide("rollback-status-modal");
        window.location.reload();
      } catch (e) {
        this.$bvModal.hide("rollback-status-modal");
        Err.handle(e);
        this.rollbackLoading = false;
      }
    },
    handleChangelogSummaryClick() {
      this.showChangelog = true;
    }
  })
});